import { defHttp } from '@/hooks/use-requests';
import type { CreateOrderParams, CreatePromoOrderParams } from '@/types/order';

// 获取订单列表
export const getOrders = (data: any) => {
  return defHttp.get({
    url: '/pre_order/',
    params: data,
    paramsSerializer: {
      indexes: null, // 这会让数组参数重复而不是带索引
    },
  });
};

// 获取订单详情/v1
export const getOrderDetail = (data: { display_id: string }) => {
  return defHttp.get({
    url: `/pre_order/get_by_no/`,
    params: data,
  });
};
// 获取预估车费和距离
export const getTransportAmount = (params: {
  cuebuddy_id: string;
  lat?: string;
  lng?: string;
  start_time: string;
  duration: number;
  parent_id?: string;
  source?: number; // 促销单视为手工单，该值需要设置为1（管理后台）
  rule_id?: string; // 促销单需要传递该参数 （即 strategy_id）

}) => {
  return defHttp.post({
    url: '/pre_order/fare/',
    data: params,
  });
};
// 获取预估车费和距离
export const getTransportAmountNoAuth = (params: {
  cuebuddy_id: string;
  lat?: string;
  lng?: string;
  start_time: string;
  duration: number;
  parent_id?: string;
  source?: number; // 促销单视为手工单，该值需要设置为1（管理后台）
  rule_id?: string; // 促销单需要传递该参数 （即 strategy_id）

}) => {
  return defHttp.post({
    url: '/pre_order/no_auth/fare/',
    data: params,
  }, {
    withToken: false,
  });
};

// 创建订单
export const createOrder = (params: CreateOrderParams) => {
  return defHttp.post({
    url: '/pre_order/',
    data: params,
  });
};

export const createPromoOrder = (params: CreatePromoOrderParams) => {
  return defHttp.post({
    url: '/pre_order/no_auth/alcohol/',
    data: params,
  }, {
    withToken: false,
  });
};

// 支付订单
export const payOrder = (id: string) => {
  return defHttp.post({
    url: `/orders/${id}/pay`,
  });
};

// 助教核销
export const verifyOrder = (display_id: string) => {
  return defHttp.post({
    url: `/pre_order/${display_id}/exchange/`,
  });
};

// 确认接单
export const confirmOrder = (id: string) => {
  return defHttp.post({
    url: `/pre_order/${id}/respond/`,
  });
};

// 订单获取扫码信息
export const getOrderScanInfo = (id: string) => {
  return defHttp.get({
    url: `/v1/pre_order/${id}/qrcode/`,
  });
};

// 获取签名
export const getSign = (params: { url: string }) => {
  return defHttp.get({
    url: `/pre_order/qrcode/`,
    params,
  });
};
// 不需要token的获取签名/public/get_wx_sign/
export const getSignNoToken = (params: { url: string }) => {
  return defHttp.get({
    url: `/public/get_wx_sign/`,
    params,
  });
};
// 教练操作（拍照等）/pre_order/:id/arrive/
export const coachOperate = (id: string, params: { arrived_image: string }) => {
  return defHttp.post({
    url: `/pre_order/${id}/arrive/`,
    data: params,
  });
};
